import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=530e215b&lang=pug"
import script from "./DeleteBtn.vue?vue&type=script&lang=js"
export * from "./DeleteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports